import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { styled } from '@mui/material/styles';
import '../leftPanel/style/device-list.sass';
import { CloseRounded, FiberManualRecordTwoTone, HighlightOffRounded, } from '@mui/icons-material';
import brand from 'shared/app/model/branding';
import * as classnames from 'classnames';
import { Tooltip } from '@mui/material';
import DeviceMalfunction from '../images/device-icons/autoscan/device-malfunction.svg';
import RideIcon from '../images/device-icons/autoscan/device-ride.svg';
import ParkingIcon from '../images/device-icons/autoscan/device-parking.svg';
import DeviceShared from '../images/device-icons/autoscan/device-shared.svg';
import DeviceSharedFromMe from '../images/device-icons/autoscan/device-share-from-me.svg';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { DeviceIconState } from 'console/device/icon/types';
import { translate_device_icon_state } from 'console/device/icon/transform';
import { getSharedAccountList } from 'console/device/icon/shared';
const PREFIX = 'GetDeviceStateIcon';
const classes = {
    font_size: `${PREFIX}-font_size`,
    grey_color: `${PREFIX}-grey_color`,
    red_color: `${PREFIX}-red_color`,
    green_color: `${PREFIX}-green_color`,
    blue_color: `${PREFIX}-blue_color`,
};
const StyledTooltip = styled(Tooltip)(() => ({
    '& .MuiSvgIcon-root': { width: '1em', height: '1em' },
    [`& .${classes.font_size}`]: { fontSize: 28 },
    [`& .${classes.grey_color}`]: { fill: '#757575' },
    [`& .${classes.red_color}`]: { fill: '#f11716' },
    [`& .${classes.green_color}`]: { fill: '#21ba45' },
    [`& .${classes.blue_color}`]: { fill: '#3a59e7' },
}));
export const GetDeviceStateIcon = memo(function GetDeviceStateIcon({ state, white, className, ...rest }) {
    const icon_class = !white
        ? `ui-icon-device-${state}`
        : `ui-icon-device-${state}-white`;
    const is_zont = brand.code !== 'autoscan';
    switch (state) {
        case DeviceIconState.no_service:
            return (_jsx(HighlightOffRounded, { className: classnames(classes.font_size, classes.grey_color, className), ...rest }));
        case DeviceIconState.not_on_operation:
            return (_jsx(CloseRounded, { className: classnames(classes.font_size, classes.red_color, className), ...rest }));
        case DeviceIconState.malfunction:
            return (_jsx(DeviceMalfunction, { className: classnames('MuiSvgIcon-root', classes.font_size, className), ...rest }));
        case DeviceIconState.online:
            return is_zont ? (
            //@ts-ignore
            _jsx("div", { className: classnames('ui-device-list-device-icon', icon_class, className), ...rest })) : (_jsx(FiberManualRecordTwoTone, { className: classnames(classes.font_size, classes.green_color, className), ...rest }));
        case DeviceIconState.online_ride:
            return (_jsx(RideIcon, { className: classnames('MuiSvgIcon-root', classes.font_size, classes.green_color, className), ...rest }));
        case DeviceIconState.online_parking:
            return (_jsx(ParkingIcon, { className: classnames('MuiSvgIcon-root', classes.font_size, classes.blue_color, className), ...rest }));
        case DeviceIconState.offline:
            return is_zont ? (
            //@ts-ignore
            _jsx("div", { className: classnames('ui-device-list-device-icon', icon_class, className), ...rest })) : (_jsx(FiberManualRecordTwoTone, { className: classnames(classes.font_size, classes.red_color, className), ...rest }));
        case DeviceIconState.offline_ride:
            return (_jsx(RideIcon, { className: classnames('MuiSvgIcon-root', classes.font_size, classes.red_color, className), ...rest }));
        case DeviceIconState.offline_parking:
            return (_jsx(ParkingIcon, { className: classnames('MuiSvgIcon-root', classes.font_size, classes.red_color, className), ...rest }));
        case DeviceIconState.guard_on:
        case DeviceIconState.guard_enabling:
        case DeviceIconState.guard_off:
        default:
            return (
            //@ts-ignore
            _jsx("div", { className: classnames('ui-device-list-device-icon', icon_class, className), ...rest }));
    }
});
export const GetDeviceIconWithTooltip = memo(function GetDeviceIconWithTooltip({ state, white, className, }) {
    return (_jsx(StyledTooltip, { title: translate_device_icon_state[state] ?? '', children: _jsx("span", { style: { display: 'inline-flex' }, children: _jsx(GetDeviceStateIcon, { state: state, white: white, className: className }) }) }));
});
export const GetSharedDeviceIcon = memo(function GetSharedDeviceIcon(props) {
    const { dev, user_id, ...rest } = props;
    const accounts = getSharedAccountList(dev);
    if (accounts == null) {
        return null;
    }
    return dev.user_id === user_id ? (_jsx(StyledTooltip, { className: "sharedIcon", title: `Совместный доступ предоставлен${accounts.length > 0
            ? ':\n' + accounts.toString().replace(/,/g, '\n')
            : ''}`, children: _jsx("span", { children: _jsx(DeviceShared, { className: classnames('MuiSvgIcon-root', classes.font_size), ...rest }) }) })) : (_jsx(StyledTooltip, { className: "sharedIcon", title: `Совместный доступ предоставил ${dev.owner_username ?? ''}`, children: _jsx("span", { children: _jsx(DeviceSharedFromMe, { className: classnames('MuiSvgIcon-root', classes.font_size), ...rest }) }) }));
});
export const GetSharedDeviceIcon2 = memo(function GetSharedDeviceIcon2(props) {
    const { dev, user_id } = props;
    const accounts = getSharedAccountList(dev);
    if (accounts == null) {
        return null;
    }
    return dev.user_id === user_id ? (_jsx(Tooltip, { className: "sharedIcon", title: `Совместный доступ предоставлен${accounts.length > 0
            ? ':\n' + accounts.toString().replace(/,/g, '\n')
            : ''}`, children: _jsx(CustomIcon, { Icon: DeviceShared, color: "action", fontSize: "1em", viewBox: "0 0 24 24" }) })) : (_jsx(Tooltip, { className: "sharedIcon", title: `Совместный доступ предоставил ${dev.owner_username ?? ''}`, children: _jsx(CustomIcon, { Icon: DeviceSharedFromMe, color: "action", fontSize: "1em", viewBox: "0 0 24 24" }) }));
});
